<content-viewer 
  *ngIf="body" 
  [content]="body" 
  (docRendered)="handleDocRendered($event)">
</content-viewer>
<div class="-right-pane" *ngIf="isDocIndex">
  <doc-index [indexContainer]="'content-viewer'" [title]="'Within this Page'" *ngIf="docIndexReady"></doc-index>  
</div>